module.exports = __webpack_public_path__ + "img/icon-2.991b647d.png";